import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'button']

  connect () {
    this.visible = false
    this.update()
  }

  toggle () {
    this.visible = !this.visible
    this.update()
  }

  update () {
    this.inputTarget.type = this.visible ? 'text' : 'password'
    this.buttonTarget.classList.toggle('text-ladot-secondary', !this.visible)
    this.buttonTarget.classList.toggle('text-ladot-green', this.visible)
    this.buttonTarget.classList.toggle('hover:text-ladot-ink', !this.visible)
    this.buttonTarget.classList.toggle('hover:text-ladot-green', this.visible)
    this.buttonTarget.setAttribute(
      'aria-label',
      this.visible
        ? this.element.dataset.hidePasswordLabel
        : this.element.dataset.showPasswordLabel
    )
  }
}
